import styled from '@emotion/styled';
import React from 'react';
import {useTranslation} from 'react-i18next';

const PlaceholderStyle = styled.div`
  font-size: var(--font-size-small);
  font-weight: var(--placeholder-font-weight);
  text-align: center;
  background-color: var(--placeholder-bg-color);
  width: auto;
  padding: var(--gutter);
`;

export const SimplePlaceholder = ({
  customText,
}: {
  customText?: string | React.ReactElement;
}): React.ReactElement => {
  const {t} = useTranslation('common');

  return (
    <PlaceholderStyle>{customText || t('placeholder.noData')}</PlaceholderStyle>
  );
};
